import { items, WFItems } from "@/common/navigation";

export default {
    data() {
        return {
            showWFMenu: false,
            items,
            WFItems
        };
    },
    methods: {
        openMobileMenu() {
            this.$emit("mobile-menu-toggle", true);
        },
        onWFMenuItemClick() {
            this.showWFMenu = !this.showWFMenu;
        },
        onWFMenuClickOutside() {
            this.showWFMenu = false;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/MainHeader/MainHeader.js